export const ParsleyCreditCardValidator = (function() {
    /* Taken from https://github.com/gpassarelli/parsley.js-credit-card-validator and modified for our use. */
    const SELECTORS = {
        CARD_TYPE: '#PaymentTypeId',
        CARD_NUMBER: '#CardNumber'
    }

    /**
     * Helper function to get credit card brand name from credit card number.
     * @param  string number        The credit card number
     * @param  boolean check_length Should it check for length
     * @return mixed                The card brand name or null
     */
    window.getCreditCardBrand = function(number, check_length) {
        var _j, _len1,
            card_name = [],
            number = number.replace(/[ -]/g, '');

        if (!number.length) {
            return;
        }

        var check_length = (typeof check_length !== 'undefined') ? check_length : false,
            card_types = [{
                name: 'AMEX',
                pattern: /^3[47][0-9]{13}$/,
                valid_length: [15]
            }, {
                name: 'DinersClub',
                pattern: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
                valid_length: [14]
            }, {
                name: 'Discover',
                pattern: /^6(?:011|5[0-9]{2})[0-9]{12}$/,
                valid_length: [16]
            }, {
                name: 'JCB',
                pattern: /^(?:2131|1800|35\d{3})\d{11}$/,
                valid_length: [16]
            }, {
                name: 'MasterCard',
                pattern: /^5[1-5][0-9]{14}$/,
                valid_length: [16]
            }, {
                name: 'Visa',
                pattern: /^4[0-9]{12}(?:[0-9]{3})?$/,
                valid_length: [16]
            }];

        for (_j = 0, _len1 = card_types.length; _j < _len1; _j++) {
            var card = card_types[_j];

            if (card.pattern.test(number)) {
                if (check_length) {
                    if (card.valid_length.indexOf(number.length) > -1) {
                        card_name.push(card.name);
                    }
                } else {
                    card_name.push(card.name);
                }
            }
        }

        if (card_name.length) {
            return card_name.join(' ');
        }

        return null;
    };

    //---------------------------------------
    // CreditCard Number Verification
    //---------------------------------------
    window.Parsley.addValidator('creditcard',
        function(value, requirement) {
            var digit, n, _ref2, valid, _j, _len1,
                sum = 0;
            window.creditCardNumberFieldValue = value;
            const cardTypeDropdown = $(SELECTORS.CARD_TYPE);
            window.cardTypeDropdown = cardTypeDropdown.parsley();
            value = value.replace(/[ -]/g, '');
            _ref2 = value.split('').reverse();

            for (n = _j = 0, _len1 = _ref2.length; _j < _len1; n = ++_j) {
                digit = _ref2[n];
                digit = +digit;

                if (n % 2) {
                    digit *= 2;

                    if (digit < 10) {
                        sum += digit;
                    } else {
                        sum += digit - 9;
                    }
                } else {
                    sum += digit;
                }
            }

            valid = (sum % 10 === 0);
            // Checks for specific brands
            if (valid && requirement.length) {
                window.creditCardBrand = window.getCreditCardBrand(window.creditCardNumberFieldValue, true);
                if (window.creditCardBrand === undefined || window.creditCardBrand === null) {
                    valid = false;
                    return valid;
                }
                var valid_cards = requirement.split(','),
                    valid = false,
                    card = window.creditCardBrand.split(' ');
                for (var c in card) {
                    if (requirement.indexOf(card[c]) > -1) {
                        valid = true;
                    }
                }
            }

            if (window.creditCardTypeFieldValue !== window.creditCardBrand) {
                valid = false;
            }
            if (window.creditCardTypeFieldValue == window.creditCardBrand) {
                valid = true;
            }

            return valid;
        }, 32);
    //---------------------------------------
    // CVV Verification
    //---------------------------------------
    window.Parsley.addValidator('cardType',
        function(value, requirements) {
            window.creditCardTypeFieldValue = value;
            window.cardNumberField = $(SELECTORS.CARD_NUMBER).parsley();
            window.creditCardBrand = window.getCreditCardBrand(window.creditCardTypeFieldValue, true);
            window.cardNumberField.validate();

            if (window.creditCardTypeFieldValue !== window.creditCardBrand) {
                return false;
            }
            if (window.creditCardTypeFieldValue == window.creditCardBrand) {
                return true;
            }
        }, 32);

    //---------------------------------------
    // CVV Verification
    //---------------------------------------
    window.Parsley.addValidator('cvv',
        function(value) {
            return /^[0-9]{3,4}$/.test(value);
        }, 32);
}());